module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAMCAIAAADgcHrrAAAAK3RFWHRDcmVhdGlvbiBUaW1lAHphIDMxIGRlYyAyMDA1IDE2OjE3OjUzICswMTAw1nyQNAAAAAd0SU1FB9UMHw8bIjSnQLcAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAEZ0FNQQAAsY8L/GEFAAAAcklEQVR42r3NzQqAIBAE4DF8ss69eC8SJHmyH8KVTbefa2uHBhEW5mMMowMSQPK/JkqTrLTTLV9Tmoxk751FYc7QBGrUO1e8MMPMelOY9865pso8+ZcZtD1owT5qxTaAgkUMSGvFEM352UwLk0NpPrNwAE6uTuku28ZSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/nl-be.png
// module id = bNcu
// module chunks = 13